import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.isOpen = false
    
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }

  toggle(event) {
    event.stopPropagation()
    this.isOpen = !this.isOpen
    this.menuTarget.classList.toggle('hidden', !this.isOpen)
  }

  close() {
    this.isOpen = false
    this.menuTarget.classList.add('hidden')
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target) && this.isOpen) {
      this.close()
    }
  }
}
